import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SceneCountdown as SceneCountdownType } from "@ltypes/scene";
import DisplayForm from "@components/forms/DisplayForm/DisplayForm";
import TextField from "@components/forms/TextField/TextField";
import User from "@ltypes/user";
import Product from "@ltypes/product";
import { displayModes } from "../../../constants";
import Color from "@components/forms/Color/Color";

type SceneCountdownProps = {
    scene: SceneCountdownType,
    onChange: (field: string, value: string|number) => void,
};

function SceneCountdown(props: SceneCountdownProps) {

    const { t } = useTranslation();
    const user: User = useSelector((state: any) => state.user);
    const product: Product = useSelector((state: any) => state.product);

    const getDateFormatted = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    };

    const handleDisplayModeChange = (value: number) => {
        props.onChange('display_mode', value);
        const today: Date = new Date();

        let startTime = new Date();
        let targetTime = new Date(startTime);
        targetTime.setDate(startTime.getDate() + 7);

        if(value === 1) { // Noel
            targetTime = new Date(today.getFullYear(), 11, 25, 23, 59, 59);
            if(today > targetTime) targetTime = new Date(today.getFullYear()+1, 11, 25, 0, 0, 0);
            targetTime.setHours(0);
            targetTime.setMinutes(0);
            targetTime.setSeconds(0);

            startTime = new Date(targetTime.getFullYear()-1, 11, 25);
        }
        else if(value === 2) { // Halloween
            targetTime = new Date(today.getFullYear(), 9, 31, 23, 59, 59);
            if(today > targetTime) targetTime = new Date(today.getFullYear()+1, 9, 31, 0, 0, 0);
            targetTime.setHours(0);
            targetTime.setMinutes(0);
            targetTime.setSeconds(0);

            startTime = new Date(targetTime.getFullYear()-1, 9, 31);
        }
        else if(value === 3) { // GTA 6
            targetTime = new Date(today.getFullYear(), 4, 26, 23, 59, 59);
            if(today > targetTime) targetTime = new Date(today.getFullYear()+1, 4, 26, 0, 0, 0);
            targetTime.setHours(0);
            targetTime.setMinutes(0);
            targetTime.setSeconds(0);

            startTime = new Date(2023, 11, 5);
        }

        props.onChange('start_time', getDateFormatted(startTime));
        props.onChange('target_time', getDateFormatted(targetTime));
    };

    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <DisplayForm label={t('page.scenes.data.display_mode')} value={props.scene.display_mode} items={displayModes[product.model.type].countdown.map((index: number) => ({
                            id: index,
                            background: `countdown-${index}`,
                        }))} productModelType={product.model.type} onChange={handleDisplayModeChange}/>
                    </div>
                    <div className="col-12">
                        <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                    <div className="row g-3">
                        {props.scene.display_mode === 0 && (
                            <>
                                <div className="col-12">
                                    <TextField label={t('page.scenes.data.text')} value={props.scene.text} onChange={(value: string) => props.onChange('text', value)}/>
                                </div>

                                <div className="col-12">
                                    <TextField label={t('page.scenes.data.start_time')} value={props.scene.start_time} onChange={(value: string) => props.onChange('start_time', value)}/>
                                </div>

                                <div className="col-12">
                                    <TextField label={t('page.scenes.data.target_time')} value={props.scene.target_time} onChange={(value: string) => props.onChange('target_time', value)}/>
                                </div>

                                <div className="col-12">
                                    <Color label={t('page.scenes.data.bgcolor')} value={props.scene.color1} onChange={(value: string) => props.onChange('color1', value)}/>
                                    <Color label={t('page.scenes.data.textcolor')} value={props.scene.color2} onChange={(value: string) => props.onChange('color2', value)}/>
                                    <Color label={t('page.scenes.data.progresscolor')} value={props.scene.color3} onChange={(value: string) => props.onChange('color3', value)}/>
                                </div>
                            </>
                        )}
                    </div>
                </div>
        </div>
    );
}

export default SceneCountdown;
